import {fillFormInputs, handleApiForm, hideField, showField, tokenInput} from "../../../forms";
import {closeModal, openModal, url} from "../../../utilities";
import * as $ from "jquery";
import {toastAlert} from "../../../toastAlert";
import Spinner from "../../../spinner";
import axios from "axios";
import {confirmModal} from "../../../confirmModal";
import moment from "moment";
import FileDownload from "js-file-download";

export const financial_obligations_page = () => {
    const financial_obligation_table = $('[data-app-financial_obligations="table"]');
    const submitted_financial_obligation_table = $('[data-app-submitted_financial_obligations="table"]');
    const body = $('body');

    const financialObligationTableApi = financial_obligation_table.DataTable({
        filters: {
            columns: [
                {
                    index: 6,
                    title: 'Status',
                    values: [
                        {
                            text: 'nie zapłacono',
                            value: 1,
                            custom: (settings, searchData, index, rowData) => {
                                return parseInt(rowData[6]['@data-order']) === 1;
                            }
                        },
                        {
                            text: 'zapłacono',
                            value: 2,
                            custom: (settings, searchData, index, rowData) => {
                                return parseInt(rowData[6]['@data-order']) === 2;
                            }
                        },
                        {
                            text: 'nie rozliczono',
                            value: 3,
                            custom: (settings, searchData, index, rowData) => {
                                return parseInt(rowData[6]['@data-order']) === 3;
                            }
                        },
                        {
                            text: 'rozliczono',
                            value: 4,
                            custom: (settings, searchData, index, rowData) => {
                                return parseInt(rowData[6]['@data-order']) === 4;
                            }
                        }
                    ]
                },
            ]
        }
    }).api();

    const submittedFinancialObligationTableApi = submitted_financial_obligation_table.DataTable({
        filters: {
            columns: [
                {
                    index: 5,
                    title: 'Status',
                    values: [
                        {
                            text: 'szkic',
                            value: 1,
                            custom: (settings, searchData, index, rowData) => {
                                return parseInt(rowData[5]['@data-order']) === 1;
                            }
                        },
                        {
                            text: 'zgłoszone',
                            value: 2,
                            custom: (settings, searchData, index, rowData) => {
                                return parseInt(rowData[5]['@data-order']) === 2;
                            }
                        },
                        {
                            text: 'zatwierdzone',
                            value: 3,
                            custom: (settings, searchData, index, rowData) => {
                                return parseInt(rowData[5]['@data-order']) === 3;
                            }
                        }
                    ]
                },
            ]
        }
    }).api();

    financial_obligation_table.on('draw.dt', function () {
        $('[data-bs-toggle="tooltip"]').each(function () {
            new bootstrap.Tooltip(this)
        })
    });

    submitted_financial_obligation_table.on('draw.dt', function () {
        $('[data-bs-toggle="tooltip"]').each(function () {
            new bootstrap.Tooltip(this)
        })
    });

    function getStatusesByObligationType(obligationType) {
        let statuses = {};
        if (obligationType == 1) {
            statuses = {
                '1': 'Nie zapłacono',
                '2': 'Zapłacono',
            };
        } else if (obligationType == 2) {
            statuses = {
                '3': 'Nie rozliczono',
                '4': 'Rozliczono',
            };
        } else {
            statuses = {
                '1': 'Nie zapłacono',
                '2': 'Zapłacono'
            };
        }

        return statuses;
    }

    function getStatusbyId(id) {
        let statuses = {
            '1': 'Szkic',
            '2': 'Zgłoszone',
            '3': 'Zatwierdzone',
        };

        return statuses[id];
    }

    function getFinancialOblifationStatusbyId(id) {
        let statuses = {
            '1': 'Nie zapłacono',
            '2': 'Zapłacono',
            '3': 'Nie rozliczono',
            '4': 'Rozliczono',
        };

        return statuses[id];
    }

    if (financial_obligation_table.length > 0) {
        // Generowanie wydruku zbiorowego
        $("#btnObligationsSelectedToPdf").click(async function (e) {
            e.preventDefault();

            let spinner = new Spinner(null, 'Trwa generowanie wydruku zbiorowego');

            try {
                const filteredRows = financialObligationTableApi.rows({ search: 'applied' }).nodes();

                let ids = [];
                $(filteredRows).each(function () {
                    const rowId = $(this).data('app-id');
                    if (rowId) {
                        ids.push(`ids[]=${rowId}`);
                    }
                });

                if (ids.length === 0) {
                    spinner.destroy();
                    alert("Brak zobowiązań do wydruku.");
                    return;
                }

                const queryString = ids.join('&');

                const response = await axios.get(`${url('app/reckonings/financial-obligations/pdf')}?${queryString}`, {
                    responseType: 'blob'
                });

                spinner.destroy();
                FileDownload(response.data, 'Zobowiazania.pdf');

            } catch (err) {
                spinner.destroy();
                console.error(err);
            }
        });


    }
    /// Forms
    // Common
    $('#addFinancialObligation [name="financial_obligation_type_id"]').change(function () {
        const defaultAmount = $(this).find(`option[value="${$(this).val()}"]`).attr('data-default_amount');
        const defaultPaymentDate = $(this).find(`option[value="${$(this).val()}"]`).attr('data-default_payment_date');
        const obligationType = $(this).find(`option[value="${$(this).val()}"]`).attr('data-obligation_type');
        const form = $(this).closest('form');
        hideField(form, 'paid_at');

        const amountLabel = document.getElementById('add_amount_label');
        const paymentDateLabel = document.getElementById('add_payment_date_label');
        const paidAtLabel = document.getElementById('add_paid_at_label');


        if (obligationType == 1) {
            amountLabel.textContent = 'Kwota';
            paymentDateLabel.textContent = 'Termin płatności';
            paidAtLabel.textContent = 'Data zapłaty';
        } else if (obligationType == 2) {
            amountLabel.textContent = 'Liczba godzin';
            paymentDateLabel.textContent = 'Termin wykonania';
            paidAtLabel.textContent = 'Data rozliczenia';
        }

        const statusSelect = form.find('[name="status"]');
        statusSelect.empty(); // Clear existing options

        const statuses = getStatusesByObligationType(obligationType);
        for (const [value, text] of Object.entries(statuses)) {
            statusSelect.append(new Option(text, value));
        }

        const amountInput = form.find('[name="amount"]');
        if (amountInput.attr('data-app-changed') !== "true") {
            amountInput.val(defaultAmount);
        }

        const paymentDate = form.find('[name="payment_date"]');
        if (paymentDate.attr('data-app-changed') !== "true" && defaultPaymentDate) {
            paymentDate.val(moment().add(defaultPaymentDate, 'days').format('DD/MM/YYYY'));
        }
    }).change();

    $('#addFinancialObligation [name="amount"], #addFinancialObligation [name="payment_date"]').change(function () {
        $(this).attr('data-app-changed', 'true');
    })

    $('#addFinancialObligation [name="status"], #editFinancialObligation [name="status"]').change(function () {
        const form = $(this).closest('form');

        if (parseInt($(this).val()) === 2 || parseInt($(this).val()) === 4) {
            showField(form, 'paid_at');
        } else {
            hideField(form, 'paid_at');
        }
    }).change();

    $('#addFinancialObligation [name="paid_at"], #editFinancialObligation [name="paid_at"]').change(function () {
        const form = $(this).closest('form');
        const paidAtInput = form.find('[name="paid_at"]');

        if ($(this).is(':checked') && paidAtInput.val().length === 0) {
            paidAtInput.val(moment().format('DD/MM/YYYY'))
        }
    }).change();

    // Add
    $('[data-bs-target="#addFinancialObligationModal"]').click(function () {
        $("#addFinancialObligation").find('[name="amount"], [name="payment_date"]').attr('data-app-changed', 'false');
    })

    handleApiForm('#addFinancialObligation', ({response, form}) => {
        if (response.data.code === 200) {
            closeModal('#addFinancialObligationModal');
            fillFormInputs(form, {
                comments: '',
                amount: '',
                status: 1,
                paid_at: null
            })

            hideField(form, 'paid_at');

            for (const financialObligation of response.data.financialObligations) {
                let row = $(`
                    <tr class="${financialObligation.is_payment_exceeded ? 'table-row-danger' : ''}" data-app-id="${financialObligation.id}">
                        <td>${financialObligation.member.user.displayName}</td>
                        <td>${financialObligation.type.name}</td>
                        <td>-</td>
                        <td>${financialObligation.amount} ${financialObligation.type.obligation_type == 2 ? 'h' : 'zł'}</td>
                        <td>${financialObligation.payment_date ? moment(financialObligation.payment_date).format('DD/MM/YYYY') : '-'}</td>
                        <td>${moment(financialObligation.created_at).format('DD/MM/YYYY HH:mm')}</td>
                        <td>
                            <span class="badge ${financialObligation.status == 2 || financialObligation.status == 4 ? 'bg-primary' : 'bg-secondary'}" data-bs-toggle="tooltip" title="${(parseInt(financialObligation.status) === 2 && financialObligation.paid_at) ? moment(financialObligation.paid_at).format('DD/MM/YYYY') : ''}">
                                ${financialObligation.status_name}
                            </span>
                        </td>
                        <td>
                            ${financialObligation.comments.length > 0 ? (
                    `<span data-bs-toggle="tooltip" title="${financialObligation.comments}">
                                    <i class="fas fa-info-circle text-secondary"></i>
                                </span>`
                ) : '-'}
                        </td>
                        <td>
                            <button data-app-id="${financialObligation.id}" type="button" class="btn btn-sm text-white btnChangeStatusOfFinancialObligation ${financialObligation.status == 2 || financialObligation.status == 4 ? 'btn-secondary' : 'btn-info' }">
                                <span data-bs-toggle="tooltip" title="Oznacz jako rozliczone">
                                    <i class="fas fa-money-bill"></i>
                                </span>
                            </button>
                            <button data-app-id="${financialObligation.id}" type="button" class="btn btn-sm btn-primary btnEditFinancialObligation">
                                <i class="fas fa-pencil-alt"></i>
                            </button>
                            <button data-app-id="${financialObligation.id}" type="button" class="btn btn-sm btn-danger btnDeleteFinancialObligation">
                                <i class="fas fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                `)

                financialObligationTableApi.rows.add(row);
            }

            financialObligationTableApi.draw();

            toastAlert('Pomyślnie dodano nowe zobowiązania');
        }
    })

    $('#addSubmittedFinancialObligationModal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let financialObligationId = button.data('app-id');
        let obligationId = button.data('obligation-id')

        const submittedAmountLabel = document.getElementById('add_submitted_amount_label');
        if (obligationId === 1) {
            submittedAmountLabel.textContent = "Kwota";
        } else if (obligationId === 2) {
            submittedAmountLabel.textContent = "Liczba godzin";
        }
        else{
            submittedAmountLabel.textContent = "Liczba godzin";
        }

        if(financialObligationId!==undefined && financialObligationId !== null){
            $('#financial_obligation_id_hidden').val(financialObligationId);
        }
    })

    $('#editSubmittedFinancialObligationModal').on('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let obligationId = button.data('obligation-id');

        const submittedAmountLabel = document.getElementById('edit_submitted_amount_label');
        if (obligationId === 1) {
            submittedAmountLabel.textContent = "Kwota";
        } else if (obligationId === 2) {
            submittedAmountLabel.textContent = "Liczba godzin";
        }

    })

    handleApiForm('#addSubmittedFinancialObligation', ({response, form}) => {
        console.log(response.data);
        if (response.data.code === 200) {
            closeModal('#addSubmittedFinancialObligationModal');
            fillFormInputs(form, {
                description: '',
                details: '',
                amount: '',
            })

            for (const financialObligation of [response.data.submittedFinancialObligation]) {
                let row = $(`
                    <tr>
                        <td>${financialObligation.member.user.first_name} ${financialObligation.member.user.last_name}</td>
                        <td>${financialObligation.description}</td>
                        <td>${financialObligation.amount} ${financialObligation.financialObligation.type ? (financialObligation.financialObligation.type.obligation_type == 2 ? 'h' : 'zł') : 'zł'}</td>
                        <td>${financialObligation.financialObligation.type ? financialObligation.financialObligation.type.name : 'Faktura'}</td>
                        <td>${moment(financialObligation.created_at).format('DD/MM/YYYY HH:mm')}</td>
                        <td>
                            <span class="badge ${parseInt(financialObligation.status) === 3 ? 'bg-primary' : 'bg-secondary'}" data-bs-toggle="tooltip">
                               ${getStatusbyId(financialObligation.status)}
                            </span>
                        </td>
                        <td>${financialObligation.author.first_name ? financialObligation.author.first_name : ''} ${financialObligation.author.last_name ? financialObligation.author.last_name : ''}</td>
                        <td>
                            ${financialObligation.details.length > 0 ? (
                    `<span data-bs-toggle="tooltip" title="${financialObligation.details}">
                                    <i class="fas fa-info-circle text-secondary"></i>
                                </span>`
                ) : '-'}
                        </td>
                        <td>
                        ${parseInt(financialObligation.status) === 3 ? '' : (`
                            <button data-app-id="${financialObligation.id}" type="button" class="btn btn-sm btn-primary btnEditSubmittedFinancialObligation">
                                <i class="fas fa-pencil-alt"></i>
                            </button>
                            <button data-app-id="${financialObligation.id}" type="button" class="btn btn-sm btn-danger btnDeleteSubmittedFinancialObligation">
                                <i class="fas fa-trash"></i>
                            </button>
                            <form data-confirm_color="warning"
                                  data-confirm='Czy na pewno chcesz wysłać to zgłoszenie do zatwierdzenia?'
                                  method="post"
                              
                                  action="${url(`app/reckonings/submitted-financial-obligations/${financialObligation.id}/submit`)}">
                                  ${tokenInput()}
                                  <input type="hidden" name="id" value="${financialObligation.id}">
                                  <button class="btn btn-sm btn-secondary btnSubmitSubmittedFinancialObligation mt-1">
                                      <i class="fas fa-paper-plane me-2"></i>Zgłoś
                                  </button>
                            </form>`)}

                        </td>
                    </tr>
                `)

                submittedFinancialObligationTableApi.rows.add(row);
            }

            submittedFinancialObligationTableApi.draw();

            toastAlert('Pomyślnie dodano nowe zgłoszenie');
        }
    })

    // Edit
    // load data


    $('#editFinancialObligation [name="financial_obligation_type_id"]').change(function () {
        // const defaultAmount = $(this).find(`option[value="${$(this).val()}"]`).attr('data-default_amount');
        // const defaultPaymentDate = $(this).find(`option[value="${$(this).val()}"]`).attr('data-default_payment_date');
        const obligationType = $(this).find(`option[value="${$(this).val()}"]`).attr('data-obligation_type');
        const form = $(this).closest('form');
        hideField(form, 'paid_at');

        const amountLabel = document.getElementById('edit_amount_label');
        const paymentDateLabel = document.getElementById('edit_payment_date_label');
        const paidAtLabel = document.getElementById('edit_paid_at_label');

        if (obligationType == 2) {
            amountLabel.textContent = 'Liczba godzin';
            paymentDateLabel.textContent = 'Termin wykonania';
            paidAtLabel.textContent = 'Data rozliczenia';
        } else {
            amountLabel.textContent = 'Kwota';
            paymentDateLabel.textContent = 'Termin płatności';
            paidAtLabel.textContent = 'Data zapłaty';
        }

        const statusSelect = form.find('[name="status"]');
        statusSelect.empty();

        const statuses = getStatusesByObligationType(obligationType);
        for (const [value, text] of Object.entries(statuses)) {
            statusSelect.append(new Option(text, value));
        }
    }).change();

    let currentId = null;

    body.on('click', '.btnEditFinancialObligation', async function () {
        const spinner = new Spinner();
        currentId = $(this).data('app-id');

        const form = $('#editFinancialObligation');

        try {
            const response = await axios.get(window.GET_FINANCIAL_OBLIGATION_URL.replace('ID', currentId));

            if (response.data.code !== 200) {
                if (response.data.errors) {
                    throw new Error();
                }

                return;
            }

            const financialObligation = response.data.financialObligation;

            openModal('#editFinancialObligationModal')
            fillFormInputs(
                form,
                {
                    ...financialObligation,
                    paid_at: financialObligation.paid_at ?
                        moment(financialObligation.paid_at).format('DD/MM/YYYY') :
                        null,
                    payment_date: financialObligation.payment_date ?
                        moment(financialObligation.payment_date).format('DD/MM/YYYY') :
                        null
                },
                true
            );

            if (financialObligation.user_association_id == null) {
                hideField(form, 'user_association_id')
            } else {
                showField(form, 'user_association_id')
            }

            // if related class, block some inputs
            if (financialObligation.related_class) {
                $('[data-app-related="alert"]').show();

                form.find('[name="amount"]').attr('disabled', true);
                form.find('[name="user_association_id"]').attr('disabled', true);
                form.find('[name="payment_date"]').attr('disabled', true);
                form.find('[name="financial_obligation_type_id"]').attr('required', false);

                hideField(form, 'financial_obligation_type_id');
                showField(form, 'related_type');

                const select = form.find('[name="related_type"]');
                select.find('option').remove();

                select.append(`<option>${financialObligation.related.type_name}</option>`)
                $('[data-app-related="name"]').text(`${financialObligation.related.type_name} - ${financialObligation.related.name}`);
            } else {
                $('[data-app-related="alert"]').hide();

                form.find('[name="amount"]').attr('disabled', false);
                form.find('[name="user_association_id"]').attr('disabled', false);
                form.find('[name="payment_date"]').attr('disabled', false);
                form.find('[name="financial_obligation_type_id"]').attr('required', true);

                showField(form, 'financial_obligation_type_id');
                hideField(form, 'related_type');
            }
        } catch (err) {
            console.log(err)
            toastAlert('Nie udało się załadować danych', {type: 'danger'})
        } finally {
            spinner.destroy()
        }
    })

    body.on('click', '.btnEditSubmittedFinancialObligation', async function () {
        const spinner = new Spinner();
        currentId = $(this).data('app-id');

        const form = $('#editSubmittedFinancialObligation');

        try {
            const response = await axios.get(window.GET_SUBMITTED_FINANCIAL_OBLIGATION_URL.replace('ID', currentId));

            if (response.data.code !== 200) {
                if (response.data.errors) {
                    throw new Error();
                }

                return;
            }

            const financialObligation = response.data.submittedFinancialObligation;

            openModal('#editSubmittedFinancialObligationModal')
            fillFormInputs(
                form, financialObligation,
                true
            );


        } catch (err) {
            console.log(err)
            toastAlert('Nie udało się załadować danych', {type: 'danger'})
        } finally {
            spinner.destroy()
        }
    })

    // handle form

    handleApiForm('#editFinancialObligation', ({response, form}) => {

        if (response.data.code === 200) {
            closeModal('#editFinancialObligationModal');
            fillFormInputs(form, {
                comments: '',
                amount: '',
                status: 1,
                paid_at: null
            })

            hideField(form, 'paid_at');

            const financialObligation = response.data.financialObligation;

            let row = financialObligationTableApi.$(`tr[data-app-id="${financialObligation.id}"]`);
            if (financialObligation.member) {
                row.find(`td:nth-of-type(1)`).text(financialObligation.member.user.displayName);
            }
            row.find(`td:nth-of-type(7)`).html(`
                <span class="badge ${parseInt(financialObligation.status === 2 || financialObligation.status === 4) ? 'bg-primary' : 'bg-secondary'}" data-bs-toggle="tooltip" title="${(parseInt(financialObligation.status) === 2 && financialObligation.paid_at) ? moment(financialObligation.paid_at).format('DD/MM/YYYY') : ''}">
                    ${financialObligation.status_name}
                </span>
            `);
            if (!financialObligation.related_class) {
                row.find(`td:nth-of-type(4)`).text(financialObligation.type.obligation_type == 2 ? financialObligation.amount + ' h' : financialObligation.amount + ' zł');
            } else {
                row.find(`td:nth-of-type(4)`).text(financialObligation.amount + ' zł');
            }
            row.find(`td:nth-of-type(5)`).text(financialObligation.payment_date ? moment(financialObligation.payment_date).format('DD/MM/YYYY') : '-');
            if (!financialObligation.related_class) {
                row.find(`td:nth-of-type(2)`).text(financialObligation.type.name);
            }
            row.find(`td:nth-of-type(8)`).html(`
                ${financialObligation.comments.length > 0 ? (
                `<span data-bs-toggle="tooltip" title="${financialObligation.comments}">
                        <i class="fas fa-info-circle text-secondary"></i>
                    </span>`
            ) : '-'}
            `);

            if (financialObligation.is_payment_exceeded) {
                row.addClass('table-row-danger');
            } else {
                row.removeClass('table-row-danger');
            }

            financialObligationTableApi.row(row).invalidate();
            financialObligationTableApi.draw();

            toastAlert('Pomyślnie zaktualizowano zobowiązanie');
        }
    }, (form) => {
        form.attr('action', window.FINANCIAL_OBLIGATION_EDIT_URL.replace('ID', currentId))
    })

    handleApiForm('#editSubmittedFinancialObligation', ({response, form}) => {
        if (response.data.code === 200) {
            closeModal('#editSubmittedFinancialObligationModal');
            fillFormInputs(form, {
                description: '',
                amount: '',
                status: 1,
                details: '',
            })

            const financialObligation = response.data.submittedFinancialObligation;

            let row = submittedFinancialObligationTableApi.$(`tr[data-app-id="${financialObligation.id}"]`);
            if (financialObligation.member) {
                row.find(`td:nth-of-type(1)`).text(financialObligation.member.user.displayName);
            }
            row.find(`td:nth-of-type(6)`).html(`
                <span class="badge ${parseInt(financialObligation.status) === 3 ? 'bg-primary' : 'bg-secondary'}" data-bs-toggle="tooltip" >
                    ${getStatusbyId(financialObligation.status)}
                </span>
            `);
            row.find(`td:nth-of-type(2)`).text(financialObligation.description);
            if (!financialObligation.financialObligation.related_class) {
                row.find(`td:nth-of-type(3)`).text(financialObligation.financialObligation.type.obligation_type == 2 ? financialObligation.amount + ' h' : financialObligation.amount + ' zł');
            } else {
                row.find(`td:nth-of-type(3)`).text(financialObligation.amount + ' zł');

            }
            row.find(`td:nth-of-type(7)`).html(`
                ${financialObligation.details.length > 0 ? (
                `<span data-bs-toggle="tooltip" title="${financialObligation.details}">
                        <i class="fas fa-info-circle text-secondary"></i>
                    </span>`
            ) : '-'}
            `);

            submittedFinancialObligationTableApi.row(row).invalidate();
            submittedFinancialObligationTableApi.draw();

            toastAlert('Pomyślnie zaktualizowano zgłoszenie');
        }
    }, (form) => {
        form.attr('action', window.SUBMITTED_FINANCIAL_OBLIGATION_EDIT_URL.replace('ID', currentId))
    })


    // Delete

    body.on('click', '.btnDeleteFinancialObligation', async function () {
        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć te zobowiązanie?', {color: 'danger'});
        if (!confirm) return;

        try {
            let url = window.FINANCIAL_OBLIGATION_DELETE_URL.replace('ID', $(this).data('app-id'));
            const response = await axios.post(url);

            if (response.data.code !== 200) {
                let err = new Error(response.data.errors);
                err.code = response.data.code;

                throw err;
            }

            let row = financialObligationTableApi.$(`tr[data-app-id=${$(this).data('app-id')}]`)
            financialObligationTableApi.row(row).remove().draw();

            toastAlert('Pomyślnie usunięto zobowiązanie');
        } catch (err) {
            if (err.code === 400) {
                toastAlert(err.message, {type: 'danger'})
                return;
            }

            toastAlert('Wystąpił błąd podczas próby usunięcia zobowiązania', {type: 'danger'})
        }
    })

    body.on('click', '.btnDeleteSubmittedFinancialObligation', async function () {
        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz usunąć to zgłoszenie?', {color: 'danger'});
        if (!confirm) return;

        try {
            let url = window.SUBMITTED_FINANCIAL_OBLIGATION_DELETE_URL.replace('ID', $(this).data('app-id'));
            const response = await axios.post(url);

            if (response.data.code !== 200) {
                let err = new Error(response.data.errors);
                err.code = response.data.code;

                throw err;
            }

            let row = submittedFinancialObligationTableApi.$(`tr[data-app-id=${$(this).data('app-id')}]`)
            submittedFinancialObligationTableApi.row(row).remove().draw();

            toastAlert('Pomyślnie usunięto zgłoszenie');
        } catch (err) {
            if (err.code === 400) {
                toastAlert(err.message, {type: 'danger'})
                return;
            }

            toastAlert('Wystąpił błąd podczas próby usunięcia zgłoszenia', {type: 'danger'})
        }
    })

    body.on('click', '.btnChangeStatusOfFinancialObligation', async function () {
        let confirm = await confirmModal('Czy jesteś pewny/a, że chcesz rozliczyć to zobowiązanie?', {color: 'warning'});
        if (!confirm) return;

        try {
            let url = window.FINANCIAL_OBLIGATION_STATUS_URL.replace('ID', $(this).data('app-id'));
            const response = await axios.post(url);

            if (response.data.code !== 200) {
                let err = new Error(response.data.errors);
                err.code = response.data.code;

                throw err;
            }

            const financialObligation = response.data.financialObligation;
            console.log(financialObligation);
            let row = financialObligationTableApi.$(`tr[data-app-id=${$(this).data('app-id')}]`)

            row.find(`td:nth-of-type(7)`).html(`
                <span class="badge bg-primary" data-bs-toggle="tooltip" >
                    ${getFinancialOblifationStatusbyId(financialObligation.status)}
                </span>
            `);
            financialObligationTableApi.row(row).invalidate();
            financialObligationTableApi.draw();


            toastAlert('Pomyślnie rozliczono zobowiązanie');
        } catch (err) {
            if (err.code === 400) {
                toastAlert(err.message, {type: 'danger'})
                return;
            }

            toastAlert('Wystąpił błąd podczas próby zmiany statusu zobowiązania', {type: 'danger'})
        }
    })

    function updateFinancialObligations(form) {
        const userSelect = form.find('[name="user_association_id"]');
        const obligationSelect = form.find('[name="financial_obligation_id"]');

        const financialObligationsValuesByUser = JSON.parse(window._financial_obligations_values ?? []);
        const selectedUserId = userSelect.val();

        obligationSelect.empty();

        const obligations = financialObligationsValuesByUser[selectedUserId] || [];

        obligations.forEach(obligation => {
            const option = document.createElement('option');
            option.value = obligation.value;
            option.text = obligation.text;
            obligationSelect.append(option);
        });
    }

    $('body').on('click', '.btnAddSubmittedFinancialObligationManagementSubmission', function () {
        const form = $("#addSubmittedFinancialObligation");
        updateFinancialObligations(form);
    });

    $('#addSubmittedFinancialObligation [name="user_association_id"]').change(function () {
        const form = $("#addSubmittedFinancialObligation");
        updateFinancialObligations(form);
    });



}